import { createSlice } from '@reduxjs/toolkit';
import { IWaterSystemGeoBlocks } from '../../../types';
import { createWaterSystemGeoBlocksAsync, createWaterSystemGeoBlocksAsyncBuilder } from './asyncRequest';

interface IWaterSystemGeoBlocksData {
  items : IWaterSystemGeoBlocks[]
}

export interface WaterSystemGeoBlocksInitialState {
  data: IWaterSystemGeoBlocksData;
  selectedGeoBlock: string;
  loading: boolean;
  error: string;
  success: boolean;
}

const initialState: WaterSystemGeoBlocksInitialState = {
  data: {} as IWaterSystemGeoBlocksData,
  selectedGeoBlock: '',
  loading: false,
  error: '',
  success: false,
};

export const WaterSystemGeoBlocksSlice = createSlice({
    name: 'waterSystemGeoBlockSlice',
    initialState,
    reducers: {
      setSelectedGeoBlock:(state,action)=> {
        state.selectedGeoBlock = action.payload
      },
      resetWaterSystemGeoBlocks:(state)=>{
        state.data = initialState.data
      }
    },
    extraReducers: (builder) => {
        createWaterSystemGeoBlocksAsyncBuilder(builder)
      },
    });
    
  export const WaterSystemGeoBlocksActions = {
    ...WaterSystemGeoBlocksSlice.actions,
    createWaterSystemGeoBlocksAsync,
  };
  
  export const WaterSystemGeoBlocksReducer = WaterSystemGeoBlocksSlice.reducer;